/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

/**
 * Directive that emits an event when a click event occurs outside the host element
 */
@Directive({
  selector: '[click-outside]'
})
export class ClickOutsideDirective {

  @Output('click-outside')
  public clickOutside: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor(
    private elementRef: ElementRef
  ) {
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }
}
